'use strict';

exports.__esModule = true;
exports.InMemory = exports.LocalStorage = exports.Verbose = exports.UUID = undefined;

var _ronUuid = require('@swarm/ron-uuid');

Object.defineProperty(exports, 'UUID', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ronUuid).default;
  }
});

var _connection = require('@swarm/client/lib/connection');

Object.defineProperty(exports, 'Verbose', {
  enumerable: true,
  get: function get() {
    return _connection.Verbose;
  }
});

var _client = require('@swarm/client');

Object.defineProperty(exports, 'LocalStorage', {
  enumerable: true,
  get: function get() {
    return _client.LocalStorage;
  }
});
Object.defineProperty(exports, 'InMemory', {
  enumerable: true,
  get: function get() {
    return _client.InMemory;
  }
});

var _regeneratorRuntime = require('regenerator-runtime');

var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);

var _graphqlAnywhere = require('graphql-anywhere');

var _graphqlAnywhere2 = _interopRequireDefault(_graphqlAnywhere);

var _objectHash = require('object-hash');

var _objectHash2 = _interopRequireDefault(_objectHash);

var _rdt = require('@swarm/rdt');

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid2 = _interopRequireDefault(_ronUuid);

var _api = require('@swarm/api');

var _api2 = _interopRequireDefault(_api);

var _subscription = require('./subscription');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // for async/await work flow

var SwarmDB = function (_API) {
  _inherits(SwarmDB, _API);

  function SwarmDB(options) {
    var _ret;

    _classCallCheck(this, SwarmDB);

    var _this = _possibleConstructorReturn(this, _API.call(this, options));

    return _ret = _this, _possibleConstructorReturn(_this, _ret);
  }

  SwarmDB.prototype.execute = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee(request, callback) {
      var _this2 = this;

      var h, _iterator, _isArray, _i, _ref2, s, sub, ok;

      return _regeneratorRuntime2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              h = _subscription.GQLSub.hash(request, callback);
              _iterator = this.subs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();

            case 2:
              if (!_isArray) {
                _context.next = 8;
                break;
              }

              if (!(_i >= _iterator.length)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt('break', 17);

            case 5:
              _ref2 = _iterator[_i++];
              _context.next = 12;
              break;

            case 8:
              _i = _iterator.next();

              if (!_i.done) {
                _context.next = 11;
                break;
              }

              return _context.abrupt('break', 17);

            case 11:
              _ref2 = _i.value;

            case 12:
              s = _ref2;

              if (!s.is(h)) {
                _context.next = 15;
                break;
              }

              return _context.abrupt('return', { ok: false });

            case 15:
              _context.next = 2;
              break;

            case 17:
              if (!(request.query.definitions.length !== 1)) {
                _context.next = 19;
                break;
              }

              throw new Error('unexpected length of definitions: ' + request.query.definitions.length);

            case 19:
              _context.next = 21;
              return this.ensure();

            case 21:
              sub = new _subscription.GQLSub(this, this.client, this.cache, request, callback);

              this.subs.push(sub);
              sub.finalize(function (h) {
                var c = -1;
                for (var _iterator2 = _this2.subs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                  var _ref3;

                  if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref3 = _iterator2[_i2++];
                  } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref3 = _i2.value;
                  }

                  var _s = _ref3;

                  c++;
                  if (_s.is(h)) {
                    _this2.subs.splice(c, 1);
                    break;
                  } else {}
                }
              });
              _context.next = 26;
              return sub.start();

            case 26:
              ok = _context.sent;
              return _context.abrupt('return', {
                ok: ok,
                off: function off() {
                  return sub.off();
                }
              });

            case 28:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function execute(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return execute;
  }();

  return SwarmDB;
}(_api2.default);

exports.default = SwarmDB;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/db/lib/index.js
// module id = 6
// module chunks = 0